import React from "react";
import classes from "./WhyChooseKC.module.scss";
import CustomImage from "../../CustomImage";
import Accordion from "../../UI/Accordion/Accordion";
import useIsMobile from "../../../hooks/useIsMobile";

const WhyChooseKC = ({ countryData }: { countryData: any }) => {
  const isMobile = useIsMobile(768);
  const whyChooseKCData = countryData?.whyChooseKc ?? [];

  return (
    <section id="why-choose-kc" className={classes["wc-section"]}>
      <div className={classes["wc-container"]}>
        <h2 className={classes["wc-heading"]}>{whyChooseKCData?.title ?? ""}</h2>
        <div className={classes["wc-subtext"]} dangerouslySetInnerHTML={{ __html: whyChooseKCData?.description ?? "" }}></div>

        <div className={classes["wc-columns"]}>
          {!isMobile && (
            <div className={classes["wc-images"]}>
              <div className={classes["wc-img-back"]}>
                <CustomImage
                  src={whyChooseKCData?.backImage?.url ?? "/icons/placeholder-image.svg"}
                  alt="Why choose KC"
                  width={240}
                  height={350}
                  layout="responsive"
                  objectFit="cover"
                />
              </div>
              <div className={classes["wc-img-front"]}>
                <CustomImage
                  src={whyChooseKCData?.frontImage?.url ?? "/icons/placeholder-image.svg"}
                  alt="Why choose KC"
                  width={240}
                  height={350}
                  layout="responsive"
                  objectFit="cover"
                />
              </div>
            </div>
          )}

          <div className={classes["wc-accordion"]}>
            <Accordion titleStyles={{fontSize: '18px'}} contentStyles={{fontSize: '16px'}} items={whyChooseKCData?.services ?? []} defaultOpenIndex={0} theme="card" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseKC;
